module.exports = __webpack_public_path__ + "static/0c5b035245dae30b3bddd82243591f905d16af91561cf1a00420fa72c1f2e4b1-f343c462e26faedd7f35d8dfd440bdc6.jpeg";